import { html } from "../helpers/stringHTML";

export function initCustomSelects(container = document) {
    const selects = container.querySelectorAll("select:not([data-customized])");

    selects.forEach((select) => {
        select.dataset.customized = "true";
        select.style.display = "none";

        const wrapper = document.createElement("div");
        wrapper.className = "custom-select";
        wrapper.dataset.select = select.name;

        // триггер
        const trigger = document.createElement("div");
        trigger.className = "custom-select__trigger";

        // span для текста (с ellipsis)
        const triggerText = document.createElement("span");
        triggerText.className = "trigger-text";
        triggerText.textContent = select.options[select.selectedIndex]?.textContent || "";
        trigger.appendChild(triggerText);

        // стрелка (можно кастомизировать)
        const arrow = document.createElement("span");
        arrow.className = "arrow";
        arrow.innerHTML = html`
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.07992 8.95035L10.5999 15.4704C11.3699 16.2404 12.6299 16.2404 13.3999 15.4704L19.9199 8.95035"
                    stroke="#10100F"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        `;

        trigger.appendChild(arrow);

        wrapper.appendChild(trigger);

        // контейнер опций
        const optionsContainer = document.createElement("div");
        optionsContainer.className = "custom-options";

        [...select.options].forEach((option) => {
            const span = document.createElement("span");
            span.className = "custom-option";

            // вложенный span для текста
            const text = document.createElement("span");
            text.className = "option-text";
            text.textContent = option.textContent;

            span.appendChild(text);
            span.dataset.value = option.value;

            if (option.selected) span.classList.add("selected");
            optionsContainer.appendChild(span);

            span.addEventListener("click", () => {
                triggerText.textContent = text.textContent;
                optionsContainer.querySelectorAll("span").forEach((s) => s.classList.remove("selected"));
                span.classList.add("selected");
                select.value = span.dataset.value;
                wrapper.classList.remove("open");
            });
        });

        wrapper.appendChild(optionsContainer);
        select.parentNode.insertBefore(wrapper, select.nextSibling);

        trigger.addEventListener("click", () => {
            document.querySelectorAll(".custom-select.open").forEach((el) => {
                if (el !== wrapper) el.classList.remove("open");
            });
            wrapper.classList.toggle("open");
        });
    });

    // глобальный слушатель для закрытия при клике вне селекта
    if (!document.body.dataset.customSelectListeners) {
        document.addEventListener("click", (e) => {
            if (!e.target.closest(".custom-select")) {
                document.querySelectorAll(".custom-select.open").forEach((el) => el.classList.remove("open"));
            }
        });
        document.body.dataset.customSelectListeners = "true";
    }
}
